/* eslint-disable @typescript-eslint/no-unused-vars */
import { TopBar } from '@/layouts/TopBar';
import Paths from '@/routes/paths';
import FormStepperHeader from '@atoms/FormStepperHeader';
import { JButton } from '@atoms/JButton';
import EnterpriseFormAddress from '@enterprise/components/EnterpriseFormAddress';
import EnterpriseFormDetails from '@enterprise/components/EnterpriseFormDetails';
import EnterpriseFormVideo from '@enterprise/components/EnterpriseFormVideo';
import useCreateEnterprise from '@enterprise/hooks/useCreateEnterprise';
import EnterpriseFormProps from '@models/enterprise-form-props';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormContainerStyled } from './enterprise-form.styled';

export const EnterpriseForm = ({ mode }: EnterpriseFormProps) => {
  const { t } = useTranslation();
  const {
    stepIndex,
    setMode,
    setStepIndex,
    isDetailsFormValid,
    isAddressFormValid,
  } = useCreateEnterprise();
  const navigation = useNavigate();
  useEffect(() => {
    setMode(mode);
  }, [mode]);
  return (
    <>
      <TopBar
        title={t(mode === 'create' ? 'NEW_ENTERPRISE' : 'EDIT_ENTERPRISE')}
      >
        <JButton
          data-qa="cancel"
          onClick={() => navigation(Paths.EnterprisePage)}
          variant="text"
        >
          {t('CANCEL')}
        </JButton>
      </TopBar>

      <FormContainerStyled>
        <FormStepperHeader
          onChangeStep={(value) => setStepIndex(value)}
          clickable={
            mode === 'edit' && !!isDetailsFormValid && !!isAddressFormValid
          }
          stepIndex={stepIndex}
          titles={['DETAILS', 'ADRESS', 'VIDEO']}
        />
        {stepIndex === 0 && (
          <EnterpriseFormDetails includeFooter={true} data-qa="details-form" />
        )}
        {stepIndex === 1 && (
          <EnterpriseFormAddress includeFooter={true} data-qa="address-form" />
        )}
        {stepIndex === 2 && (
          <EnterpriseFormVideo includeFooter={true} data-qa="video-form" />
        )}
      </FormContainerStyled>
    </>
  );
};
